import { API, graphqlOperation } from "aws-amplify";
import { getMyActivities } from "@/graphql/queries";
import { MyActivityResponse } from "@/types/my-activities";
import { formatAWSDateTime } from "@/utils/dateUtils";
import dayjs from "dayjs";

export async function fetchMyActivitiesHTTP(): Promise<MyActivityResponse> {
  const record = (await API.graphql(
    graphqlOperation(getMyActivities, {
      startTime: formatAWSDateTime(dayjs().subtract(2, "year")),
      endTime: null,
    })
  )) as { data: { getMyActivities: MyActivityResponse } };

  return record?.data?.getMyActivities;
}

